
import { mapState, mapGetters, mapActions } from 'vuex';
import AppReviewUserInfoSectionUserDisplay from '@/components/common/AppReviewUserInfoSection/AppReviewUserInfoSectionUserDisplay';
import ReviewDetailDialog from './ReviewDetailDialog';
import BuyButton from './BuyButton';
import ProductBuyButton from './ProductBuyButton';

export default {
  i18nComponentKey: 'ReviewsShortsPopup.components.ReviewInfo',
  name: 'ReviewInfo',
  components: {
    AppReviewUserInfoSectionUserDisplay,
    BuyButton,
    ProductBuyButton
  },
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['productCode']),
    ...mapGetters('widget', ['isPcViewport']),
    isProductReviewsShortsPopup() {
      return !!this.productCode;
    }
  },
  methods: {
    ...mapActions('bottomSheet', ['openBottomSheet']),
    onClickDetail() {
      this.openBottomSheet({
        component: ReviewDetailDialog,
        props: {
          reviewId: this.review.id,
          isProductReviewsShortsPopup: this.isProductReviewsShortsPopup
        },
        useBackgroundBlur: false
      });
    }
  }
};
